import { store } from "../store/";
import TiktokPixel from "../tiktok-pixel";

import instance from "../store/actions/instance";
import snapchatPixel from "react-snapchat-pixel";

let FacebookInitiateCheckout = (eventId = null) => {
  const state = store.getState();
  const settings = state.store.store.settings;
  const customerDetails = state.customers;
  const cart = state.cart;

  instance.post("facebook/track/", {
    eventName: "InitiateCheckout",
    customerDetails: customerDetails,
    fbc_2: localStorage.getItem("fbc_2"),
    url: window.location.href,
    event_id: eventId,
    data: {
      content_ids: cart.cart.map((p) => p.id),
      content_name: null,
      content_type: null,
      currency: settings.currency_iso,
      value: cart.price,
      num_items: cart.number_of_items,
    },
  });
};
let TikTokInitiateCheckout = (props) => {
  const state = store.getState();
  const customerDetails = state.customers;
  const eventId = generateUniqueID(10);
  const properties = {
    content_type: "product",
    contents: props.cart.cart.map((item) => {
      return {
        content_id: item.id.toString(),
        content_name: item.name,
        price: item.total_price + item.quantityExcludedOptionsTotal,
        quantity: item.quantity,
        currency: props.settings.currency_iso,
      };
    }),

    event_id: eventId,
  };
  TiktokPixel.track("InitiateCheckout", properties);

  if (props.settings.enable_conversion_api_tiktok) {
    instance.post("tiktok/track/", {
      eventName: "InitiateCheckout",
      eventID: eventId,
      customerDetails: customerDetails,
      ttclid: localStorage.getItem("ttclid"),
      url: window.location.href,
      properties: properties,
    });
  }
};

let TikTokViewContent = (props) => {
  const state = store.getState();
  const customerDetails = state.customers;
  const eventId = generateUniqueID(10);
  const properties = {
    event_id: eventId,
    contents: [
      {
        price: props.current_product.price,
        content_id: props.current_product.id.toString(),
        content_name: props.current_product.name,
        content_type: "product",
        quantity: 1,
      },
    ],

    description: props.current_product.name,
    content_type: "product",
    currency: props.settings.currency_iso,
    value: props.current_product.price,
  };
  TiktokPixel.track("ViewContent", properties);

  if (props.settings.enable_conversion_api_tiktok) {
    instance.post("tiktok/track/", {
      eventName: "ViewContent",
      eventID: eventId,
      customerDetails: customerDetails,
      ttclid: localStorage.getItem("ttclid"),
      url: window.location.href,
      properties: properties,
    });
  }
};
function generateUniqueID(length) {
  let result = "";
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  let counter = 0;
  while (counter < length) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
    counter += 1;
  }
  return result;
}

let SnapchatCheckout = (props) => {
  const state = store.getState();
  const customerDetails = state.customers;
  const eventId = generateUniqueID(10);

  snapchatPixel.track("START_CHECKOUT", {
    client_dedup_id: eventId,
    integration: "ordable",
  });

  if (props.settings.enable_conversion_api_snapchat) {
    instance.post("snapchat/track/", {
      eventName: "START_CHECKOUT",
      eventID: eventId,
      customerDetails: customerDetails,
      sccid: localStorage.getItem("sccid"),
      url: window.location.href,
    });
  }
};

let SnapchatAddToCart = (props, product, quantity, price) => {
  const state = store.getState();
  const settings = state.store.store.settings;
  const customerDetails = state.customers;
  const eventId = generateUniqueID(10);
  const data = {
    currency: settings.currency_iso,
    price: price,
    description: product.name,
    item_ids: [product.id],
    item_category: product.category_id,
    number_items: quantity,
  };
  snapchatPixel.track("ADD_CART", {
    client_dedup_id: eventId,
    integration: "ordable",
    ...data,
  });

  if (props.settings.enable_conversion_api_snapchat) {
    instance.post("snapchat/track/", {
      eventName: "ADD_CART",
      eventID: eventId,
      customerDetails: customerDetails,
      sccid: localStorage.getItem("sccid"),
      url: window.location.href,
      additionalData: data,
    });
  }
};
export {
  FacebookInitiateCheckout,
  generateUniqueID,
  TikTokInitiateCheckout,
  TikTokViewContent,
  SnapchatCheckout,
  SnapchatAddToCart,
};
